import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { FlowChartDataService } from '@features/data-survey/services/flow-chart-data.service';
import { take, takeUntil } from 'rxjs/operators';
import { DialogService } from '@shared/services/dialog-service';
import { Subject } from 'rxjs';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogField } from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import { ValidatorHelper } from '@shared/components/platform-tool/platform-tool-dialog-definition/models/validators-model';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-platform-tool-add-snippet-editor',
  templateUrl: './platform-tool-add-snippet-editor.component.html',
  styleUrls: ['./platform-tool-add-snippet-editor.component.scss']
})
export class PlatformToolAddSnippetEditorComponent implements OnInit, IDialogView, AfterViewInit, OnDestroy  {
  showLawChageReport = false;
  panelOpenState = false;
  unsubscribe$ = new Subject<void>();
  data: DialogModel;
  snippets = [];
  selectedSnippetType: any;
  applicableOperators = [
    {'displayText': 'Create Question', operator: 0, id: 'CreateQuestion'},
    {'displayText': 'Map Existing Question', operator: 1, id: 'MapQuestion'},
    {'displayText': 'Select Value', operator: 2, id: 'Value'}
    ];
  fieldDefDic: any;
  item: any;
  ckeditorContent: any;
  ckeConfig: any;
  inputForm: FormGroup;
  dialogDefMapping: any;
  dropDownValue = {
    CountryCode: {'DisplayKey': 'name', ValueKey: 'code'},
    Currency: {DisplayKey: 'currencyName', ValueKey: 'currencyCode'},
    Language: ''
  };

  constructor(
    private flowChartDataService: FlowChartDataService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private formBuilder: FormBuilder,
    private fuseSplashScreenService: FuseSplashScreenService,

  ) {
    this.inputForm = this.formBuilder.group({});
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      removePlugins: 'horizontalrule,tabletools,specialchar,about,list,others',
      removeButtons: 'Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,PageBreak,Iframe,Font,FontSize,TextColor,BGColor,ShowBlocks,Cut,Copy,Paste,Table,Image,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,Strike,RemoveFormat,Blockquote,Subscript,Superscript,Link,Unlink,Indent,Outdent'
    };
  }

  ngOnInit() {
    this.dialogDefMapping = {
      'StringCellEditor': {editor: 'PlatformToolPremitiveTypeEditor', validators: [Validators.required]},
      'NumericCellEditor': {editor: 'PlatformToolPremitiveTypeEditor', validators: [Validators.required, ValidatorHelper.getValidatorFn(this.inputForm, 'Numeric')]},
      'DateTimeCellEditor': {editor: 'PlatformToolPremitiveTypeEditor', validators: [Validators.required]},
      'ListCellEditor': {editor: 'PlatformToolPremitiveTypeEditor'}, validators: [Validators.required],
      'MultipleChoiceEditorComponent': {editor: 'PlatformToolPremitiveTypeEditor', validators: [Validators.required]},
      'FixedMultipleChoiceEditorComponent': {editor: 'PlatformToolPremitiveTypeEditor', validators: [Validators.required]},
      'BooleanCellEditor': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]},
      'DropdownCellEditorComponent': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]},
      'StatusDropdownCellEditorComponent': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]},
      'SmartDropdownCellEditorComponent': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]},
      'CountrySelectorCellEditor': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]},
      'QuestionnaireTransferboxCellEditorComponent': {editor: 'PlatformToolDropdownEditor', validators: [Validators.required]}
    };
    const isNewSnippet = this.data.input.isNewSnippet ? true : false;
    const flowchartSectionId = this.data.input.section.id;
    const parentId = this.data.input.parentId;
    this.flowChartDataService.getNotebookSnippets(isNewSnippet, flowchartSectionId, parentId).pipe(take(1)).subscribe((s: any) => {
      if ( s.fieldValues && s.fieldValues.SnippetTemplates) {
        this.snippets = s.fieldValues.SnippetTemplates;
        this.fieldDefDic = s.fieldValues['FieldDefinitions'];

       if (this.data.input.isNewSnippet) {
         this.onselectedSnippetTypeChange({value: this.snippets[0]});
         this.data.input.name = this.data.input.name.length === 0 ? '' : this.data.input.name;
       } else {
         if (this.data.input.item.metaData && this.data.input.item.metaData.SnippetId) {
           const val = this.snippets.find((s: any) => s.id === this.data.input.item.metaData.SnippetId);
          if (val) {
            this.data.input.name = val.metaData.Title;
            this.onselectedSnippetTypeChange({value: val});
          }
         }
       }

      }
    });
  }
  ngAfterViewInit (): void {
  }

   onOkClicked() {
    let commandName = 'AddSnippetCommand';
    const platformCommand = new PlatformCommand(commandName, this.data.input.api);

    const selectedValues = [];
    this.selectedSnippetType?.metaData?.Questions?.forEach(question => {
      const type = question.metaData.SelectedOperatorId;
      let value = '';
      switch(type) {
        case 'CreateQuestion':
          value = question.metaData.QuestionTitle;
          break;
        case 'MapQuestion':
          value = question.metaData.MapQuestionFieldKey;
          break;
        case 'Value':
          value = this.inputForm.value[question.fieldKey];
          break;
        default:
          break;
      }
      selectedValues.push({title: question.title, type, value});
    });

    platformCommand.fieldValues['SnippetConfigurations'] = selectedValues;
    platformCommand.fieldValues['SnippetTitle'] = this.data.input.name;
    platformCommand.fieldValues['Article'] = this.ckeditorContent;
    platformCommand.fieldValues['SnippetTemplateId'] = this.selectedSnippetType.id;
    platformCommand.fieldValues['ParentId'] = this.data.input.parentId;
    platformCommand.fieldValues['FlowChartSectionId'] = this.data.input.section.id;
    platformCommand.fieldValues['FlowchartId'] = this.data.input.section.flowchartId;
    this.fuseSplashScreenService.show();
    const res =  this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(x => {
      this.fuseSplashScreenService.hide();
      this.flowChartDataService.invalidate();
    }, (error) => {
      this.fuseSplashScreenService.hide();
    });
    return true;
  }


  onDefaultSelectedOperatorChange(e, i, question) {
    if ( question.metaData.selectedOperatorId && question.metaData[question.metaData.selectedOperatorId]) {
      question.metaData[question.metaData.selectedOperatorId].selectedValue = {};
    }
  }

  onSelectedMapQuestionChange(e, i, question) {
    //question.metaData.mapQuestionFieldKey = question.fieldKey;
  }
  onselectedSnippetTypeChange(e) {
  this.selectedSnippetType = e.value;
    this.initItem();
    this.inputForm = this.formBuilder.group({});
    // We can't save selected value in question metaData, since this value can be object type.
    // Question metaData supports only string type.
    //const selectedValues = this.selectedSnippetType.metaData.SelectedValues ?? {};
    this.selectedSnippetType.metaData.Questions = this.selectedSnippetType.metaData.Questions.map(x => {
      x.metaData.SelectedOperatorId = x.metaData.SelectedOperatorId ?? this.applicableOperators[0].id;
      //const selectedValue = selectedValues[x.fieldKey];
      const formControl = new FormControl(x.metaData.Value, this.dialogDefMapping[x.cellEditor] ? this.dialogDefMapping[x.cellEditor].validators : [Validators.required]);
      this.inputForm.addControl(x.fieldKey, formControl);
      return x;
    });
  }

  private initItem() {
    this.item = {
      cells: {}
    };
    Object.keys(this.selectedSnippetType.metaData.Questions).forEach(key => {
      this.item.cells[key] = {};
    });
  }
  dialogField(question) {
    return {
      key        : question.fieldKey,
      title      : question.title,
      editor     : this.dialogDefMapping[question.cellEditor].editor,
      isMandatory: true,
      type       : question.dataType,
      options    : question.options,
      fieldValues: {
        ...this.dropDownValue[question.dataType]
      },
      value      : null
    } as DialogField;
  }
  onEdit(question: any) {
    const minWidth = '600px';
    const maxWidth = '600px';
    this.dialogService.showCellEditorDialog(
      this.item,
      this.fieldDefDic[question.fieldKey], minWidth, maxWidth,
      this.data.input.sourceType,
      undefined,
      {
        disableFieldSettings: '',
        flowChartSectionId : this.data.input.section.id,
        flowChartId : this.data.input.section.flowchartId,
        type : 'Questionnaire'}).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      console.log('After Edit', state);
      question.metaData.selectedValue = this.item.cells[question.fieldKey].value;
      if (state?.action === 'OK') {

      }
    });
  }
  onFieldValueChange(e) {

  }
  onFieldValidationChange(e) {

  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }
}
